import type { JSX } from "react";
import { lazy, Suspense } from "react";
import { Outlet } from "react-router";

import StandardPage from "~/containers/StandardPage";
import HeaderSidebarProfile from "~/molecules/headers/HeaderSidebarProfile";

// Lazy load drawer components - only loaded when first opened
const DocumentAddDrawer = lazy(
  () => import("~/molecules/Drawers/document/DocumentAddDrawer")
);
const BusinessContactInfoDrawer = lazy(
  () => import("~/molecules/Drawers/settings/BusinessContactInfoDrawer")
);
const BusinessWebsiteInformationDrawer = lazy(
  () => import("~/molecules/Drawers/settings/BusinessWebsiteInformationDrawer")
);
const StripeAddPaymentDetailsDrawer = lazy(
  () => import("~/molecules/Drawers/stripe/StripeAddPaymentDetailsDrawer")
);
const StripeAddPaymentDetailsFeedbackDrawer = lazy(
  () =>
    import("~/molecules/Drawers/stripe/StripeAddPaymentDetailsFeedbackDrawer")
);

const LayoutHasSidebar = (): JSX.Element => {
  return (
    <div className="flex h-screen flex-col lg:pl-72">
      <HeaderSidebarProfile />

      <main className="flex-1 overflow-y-auto py-10 pb-28">
        <StandardPage>
          <div id="CIO_message" />
          <Outlet />
        </StandardPage>
      </main>

      <Suspense fallback={null}>
        <BusinessWebsiteInformationDrawer />
        <BusinessContactInfoDrawer />
        <DocumentAddDrawer />
        <StripeAddPaymentDetailsDrawer />
        <StripeAddPaymentDetailsFeedbackDrawer />
      </Suspense>
    </div>
  );
};

export default LayoutHasSidebar;
